import React, { useState } from 'react';
import api from '../api';

export default function Login({ onLogin }: { onLogin: (user: any, tenant: any) => void }) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [form, setForm] = useState({ email: '', password: '', name: '', phone: '', password2: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const tenant = JSON.parse(localStorage.getItem('customer_tenant') || '{}');
  const color = tenant.color || '#7C3AED';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (mode === 'register') {
      if (form.password !== form.password2) return setError('Las contraseñas no coinciden');
      if (form.password.length < 6) return setError('Password mínimo 6 caracteres');
    }

    setLoading(true);
    try {
      if (mode === 'register') {
        await api.post('/api/customer/register', { email: form.email, password: form.password, name: form.name, phone: form.phone });
        setMode('login');
        setError('');
        setForm(f => ({ ...f, name: '', phone: '', password: '', password2: '' }));
        return;
      }

      const { data } = await api.post('/api/customer/login', { email: form.email, password: form.password });
      localStorage.setItem('customer_token', data.token);
      localStorage.setItem('customer_user', JSON.stringify(data.user));
      localStorage.setItem('customer_tenant', JSON.stringify(data.tenant));
      onLogin(data.user, data.tenant);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Error al conectar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', padding: '1rem' }}>
      <div style={{ background: '#1a1a2e', padding: '2rem', borderRadius: '16px', width: '100%', maxWidth: '400px', border: `1px solid ${color}44` }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🎤</div>
          <h1 style={{ color: '#fff', margin: 0, fontSize: '1.8rem' }}>{tenant.name || 'KaraokePark'}</h1>
          <p style={{ color: '#888', margin: '0.25rem 0 0' }}>Karaoke desde casa</p>
        </div>

        <div style={{ display: 'flex', marginBottom: '1.5rem', background: '#0f0f1a', borderRadius: '8px', padding: '4px' }}>
          {(['login', 'register'] as const).map(m => (
            <button key={m} onClick={() => setMode(m)} style={{ flex: 1, padding: '0.5rem', border: 'none', borderRadius: '6px', cursor: 'pointer', background: mode === m ? color : 'transparent', color: '#fff', fontWeight: mode === m ? 600 : 400 }}>
              {m === 'login' ? 'Ingresar' : 'Registrarse'}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              <input style={inp} placeholder="Nombre completo *" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
              <input style={inp} placeholder="Teléfono (opcional)" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
            </>
          )}
          <input style={inp} type="email" placeholder="Email *" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
          <input style={inp} type="password" placeholder="Contraseña *" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
          {mode === 'register' && (
            <input style={inp} type="password" placeholder="Confirmar contraseña *" value={form.password2} onChange={e => setForm(f => ({ ...f, password2: e.target.value }))} required />
          )}
          {error && <p style={{ color: '#f87171', textAlign: 'center', fontSize: '0.9rem', margin: '0 0 1rem' }}>{error}</p>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '0.85rem', background: color, border: 'none', borderRadius: '8px', color: '#fff', fontSize: '1rem', fontWeight: 600, cursor: 'pointer' }}>
            {loading ? '...' : mode === 'login' ? 'Ingresar' : 'Crear cuenta'}
          </button>
        </form>
      </div>
    </div>
  );
}

const inp: React.CSSProperties = { width: '100%', padding: '0.75rem 1rem', marginBottom: '0.75rem', background: '#0f0f1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '1rem', boxSizing: 'border-box' };
